import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch10_p02 } from "../../../layouts/ch10_p02/ch10_p02";

export class Chapter10Page2 extends AbstractStoryState implements ReturnType<typeof ch10_p02> {
    readonly bg = this.addChild(new SceneSprite());
    readonly holly = [
        this.addChild(new SceneSprite()),
        this.addChild(new SceneSprite()),
    ];
    readonly textureColorDodge = this.addChild(new SceneSprite());
    readonly lights = [
        this.addChild(SceneSprite.withPrefix("ch10_p02/")),
        this.addChild(SceneSprite.withPrefix("ch10_p02/")),
    ];

    readonly confettiContainer = this.addChild(new PIXI.Container());
    readonly confetti = list(()=>this.confettiContainer.addChild(SceneSprite.withPrefix("ch10_p02/")));

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch10_p02/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch10_p02/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch10_p02.call(this);

        this.textureColorDodge.blendMode = PIXI.BLEND_MODES.COLOR_DODGE;
        // this.textureColorDodge.filters = [PIXI.picture.getBlendFilter(PIXI.BLEND_MODES.COLOR_DODGE)];
        this.holly[0].visible = true;
        this.holly[1].visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, ()=>{
            this.holly[0].FadeOut();
            this.holly[1].FadeIn();
        });
        TweenLite.delayedCall(4, ()=>{
            this.gotoNextState({transition: "left"});
        });
    }
}